<template>
  <li>
    <div class="qnatitle">
      <h3>{{writer}}</h3>
      <p>
        <span>{{mdate}}</span>
        {{mtime}}
      </p>
    </div>
    <div class="con">
      <p @click="godetail">{{item.text}}</p>
      <div class="info">
        <div class="left">
          <a href="#" @click.prevent="likeit">
            <img src="@/assets/img/heart.png" alt="좋아요" />
            {{item.like_count}}
          </a>
          <a href="#" @click.prevent="dummy">
            <img src="@/assets/img/comment.png" alt="댓글" />
            {{item.comment_count}}
          </a>
        </div>
        <div class="right" style="display:none;">
          <a href class="modify">
            <img src="@/assets/img/modify_icon.png" alt="수정" />
          </a>
          <a href class="delete">
            <img src="@/assets/img/delete_icon.png" alt="삭제" />
          </a>
        </div>
      </div>
      <!-- 
                                    삭제 또는 수정 버튼 클릭시 노출
      -->
      <div class="alertM" style="display: none;">
        <!-- 
                                        수정, 삭제 메세지
                                        <p>삭제하시겠습니까?</p>
                                        <p>수정하시겠습니까?</p>
        -->
        <p>삭제하시겠습니까?</p>
        <div class="btnWrap">
          <a href class="submit">확인</a>
          <a href class="cancel">취소</a>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
// import moment from "moment";
export default {
  props: ["item"],
  computed: {
    writer: function() {
      if (this.item.secret === 0) {
        return this.item.writer;
      } else {
        return "익명";
      }
    },
    mdate: function() {
      return this.moment(this.item.createdAt).format("MM-DD");
    },
    mtime: function() {
      return this.moment(this.item.createdAt).format("hh:mm");
    }
  },
  methods: {
    likeit() {
      let url = this.$Constant.QnaLikeCustomApi;
      let qna_id = this.item.id;
      let writer = localStorage.getItem("default_info");
      let $that = this;

      this.$axios
        .post(url, {
          writer: writer,
          qna_id: qna_id
        })
        .then(resp => {
          // this.$store.state.qna_view.Qnalikes.push(resp.data);
          // this.$store.state.qna_view.like_toggle = true;

          let sts = resp.data.status;
          let cnt = resp.data.total;
          $that.item.like_count = cnt;

          let payload = {};
          payload.qna_id = $that.item.id;
          payload.classroom_id = $that.$store.getters.getClassroomId;
          let wrapper = {};
          if (parseInt(cnt) === 1) {
            wrapper.wayto = "ACTION_QNA_LIKEADD";
          } else if (parseInt(cnt) === 0) {
            wrapper.wayto = "ACTION_QNA_LIKEREMOVE";
          }

          wrapper.from = "";
          wrapper.to = "";
          wrapper.payload = payload;
          $that.$store.dispatch("pushWSMessage", wrapper);
        });
    },
    godetail() {
      let qnaid = this.item.id;
      this.$router.push(`/qna/detail/${qnaid}`);
    },
    dummy() {}
  }
};
</script>


<style lang="scss" scoped>
</style>